export default {
  placeholders: {
    url: 'https://www.thanx.com',
  },
  chars_remaining: '%{count} character remaining',
  chars_remaining_plural: '%{count} characters remaining',
}
